import type { ReactNode } from 'react'
import { Image, ScrollView, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Card } from '../../shared/Card'
import { images } from '../../../assets'

interface AdminAuthLayoutProps {
  children: ReactNode
}

export function AdminAuthLayout({ children }: AdminAuthLayoutProps) {
  const { t } = useTranslation()

  return (
    <ScrollView
      className="flex-1 bg-canvas-primary"
      contentContainerClassName="min-h-screen px-4 py-6 sm:px-6 lg:px-10 lg:py-8"
      keyboardShouldPersistTaps="handled"
    >
      <View className="items-start">
        <Image
          source={images.logoLight}
          style={{ width: 88, height: 56 }}
          resizeMode="contain"
          accessibilityLabel={t('adminAuth.logoAccessibilityLabel')}
        />
      </View>

      <View className="flex-1 items-center justify-center py-6 sm:py-8">
        <Card className="w-full max-w-[560px] px-5 py-8 sm:px-6 sm:py-10 lg:px-12 lg:py-12">
          {children}
        </Card>
      </View>
    </ScrollView>
  )
}
